import { Link } from "react-router";

interface Props {
	statusCode: 404 | 500;
	title: string;
	description: string;
	ctaHref: string;
	ctaLabel: string;
	assetSrc: string;
	assetAlt: string;
	debugPanel?: React.ReactNode;
}

export function ErrorPage({
	statusCode,
	title,
	description,
	ctaHref,
	ctaLabel,
	assetSrc,
	assetAlt,
	debugPanel,
}: Props) {
	return (
		<main className="relative z-10 flex min-h-screen items-center justify-center px-6 py-12">
			<section className="br-shadow-lg w-full max-w-2xl border-border border-thick bg-background/85 p-8 text-center backdrop-blur-sm">
				<img
					alt={assetAlt}
					className="mx-auto mb-8 h-auto w-full max-w-sm"
					height={260}
					loading="eager"
					src={assetSrc}
					width={360}
				/>
				<p className="font-semibold text-muted-foreground text-sm tracking-[0.22em]">
					ERROR {statusCode}
				</p>
				<h1 className="mt-3 text-balance font-semibold text-4xl tracking-tight md:text-5xl">
					{title}
				</h1>
				<p className="mx-auto mt-4 max-w-xl text-pretty text-muted-foreground text-sm md:text-base">
					{description}
				</p>
				<div className="mt-8">
					<Link
						className="inline-flex min-h-11 items-center justify-center rounded-full border border-primary bg-primary px-5 py-2 font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2"
						to={ctaHref}
					>
						{ctaLabel}
					</Link>
				</div>
				{debugPanel ? <div className="mt-6">{debugPanel}</div> : null}
			</section>
		</main>
	);
}
